import DossierFacileButton from '@flatsy/core/DossierFacile/Button'
import { SubBody2 } from '@flatsy/core/MaterialUi/Typo/Body'
import theme from '@flatsy/core/MuiTheme/theme'
import { Link } from '@material-ui/core'
import React, { useContext } from 'react'
import * as URLS from 'src/constants/Api'
import client from 'src/utils/client'
import { Body1 } from '@flatsy/core/MaterialUi/Typo'
import { getProgressionForApplicant } from '@flatsy/utils/Functions/Files/GetApplicationDossierProgression'
import i18n from '@flatsy/utils/translations'
import useStyles from './Style'
import { FileContext } from '../../../Context'
import Validated from './Validated'

const PreUploader: React.FC = () => {
  const {
    files,
    application,
    applicationId,
    Uppy,
    applicants: { current },
    qualification,
  } = useContext(FileContext)
  const classes = useStyles()
  const progression = getProgressionForApplicant({
    required_upload: current?.required_uploads,
    files: files.filesByApplicant,
  })
  const getDossierFacileUrl = async () => {
    try {
      const response = await client<{ url: string }>(
        URLS.GET_DOSSIER_FACILE_REDIRECT_URL(applicationId)
      )
      if (response && response.url) {
        window.location.href = response.url
      }
    } catch {
      //
    }
  }
  const getDossierFacileAccountUrl = async () => {
    try {
      const response = await client<{ url: string }>(URLS.GET_DOSSIER_FACILE_ACCOUNT_URL())
      if (response && response.url) {
        window.location.href = response.url
      }
    } catch {
      //
    }
  }
  const handleDossierFacile = () => {
    if (
      application?.lead?.dossier_facile_status ||
      application?.lead?.dossier_facile_status === ''
    ) {
      getDossierFacileAccountUrl()
    } else {
      getDossierFacileUrl()
    }
  }

  const isConnected = application?.lead?.dossier_facile_status
  const haveFiles = files.list && files.list.length > 0
  const dashboardUppy = Uppy?.element('pre-upload') || undefined
  const enableDossierFacile = qualification?.allow_dossier_facile
  if (progression.complete) {
    return <Validated />
  }
  return (
    <div className={classes.main} id="uppyContainer">
      {!isConnected && dashboardUppy}
      {enableDossierFacile && !haveFiles && !isConnected && (
        <Body1 className={classes.separator}>OU</Body1>
      )}
      {enableDossierFacile && !haveFiles && (
        <div className={classes.dossierFacileContainer}>
          <DossierFacileButton onClick={handleDossierFacile} connected={isConnected} />
          {!isConnected && isConnected !== '' && (
            <Link href="https://www.dossierfacile.fr/" target="_blank" className={classes.link}>
              <SubBody2 fontColor={theme.palette.primary.main}>
                {i18n.t('learn_more_about_government_initiative')}
              </SubBody2>
            </Link>
          )}
        </div>
      )}
    </div>
  )
}

export default PreUploader
